import { phappsRequest } from './apiService';
import { buildWorkflowPath } from '@/config/apiConstants';

const p = (path, params) => {
  const base = buildWorkflowPath(path);
  if (!params) return base;
  const qs = new URLSearchParams(params).toString();
  return qs ? `${base}?${qs}` : base;
};

// ---- Boards ----
export const getBoards   = ()   => phappsRequest(p('boards'), 'GET');
export const getBoard    = (id) => phappsRequest(p(`boards/${id}`), 'GET');

// ---- Cards ----
export const getCards      = (params)    => phappsRequest(p('cards', params), 'GET');
export const getCard       = (id)        => phappsRequest(p(`cards/${id}`), 'GET');
export const createCard    = (body)      => phappsRequest(p('cards'), 'POST', body);
export const updateCard    = (id, b)     => phappsRequest(p(`cards/${id}`), 'PUT', b);
export const moveCard      = (id, to_column_id, extra) => phappsRequest(p(`cards/${id}/move`), 'PUT', { to_column_id, ...extra });
export const assignCard    = (id, uid)   => phappsRequest(p(`cards/${id}/assign`), 'PUT', { assigned_to: uid });
export const deactivateCard= (id)        => phappsRequest(p(`cards/${id}`), 'DELETE');
export const linkChemist   = (id, cid)   => phappsRequest(p(`cards/${id}/link-chemist`), 'PUT', { chemist_id: cid });
export const checkDuplicate= (params)    => phappsRequest(p('cards/check-duplicate', params), 'GET');
export const sendTrainingEmail = (id)    => phappsRequest(p(`cards/${id}/send-training-email`), 'POST', {});

// ---- Comments (card-level) ----
export const getComments = (id)          => phappsRequest(p(`cards/${id}/comments`), 'GET');
export const addComment  = (id, comment) => phappsRequest(p(`cards/${id}/comments`), 'POST', { comment });

// ---- Comments (chemist-level — aggregated across all linked cards) ----
export const getChemistComments = (chemistId)           => phappsRequest(p('chemist-comments', { chemist_id: chemistId }), 'GET');
export const addChemistComment  = (chemistId, comment)  => phappsRequest(p('chemist-comments'), 'POST', { chemist_id: chemistId, comment });

// ---- App Status (onboarding cards) ----
export const getAppStatus    = (id)       => phappsRequest(p(`cards/${id}/apps`), 'GET');
export const updateAppStatus = (id, apps) => phappsRequest(p(`cards/${id}/apps`), 'PUT', { apps });
export const syncAppStatus   = (id)       => phappsRequest(p(`cards/${id}/sync-apps`), 'POST', {});

// ---- Tags ----
export const getTags   = (id)           => phappsRequest(p(`cards/${id}/tags`), 'GET');
export const addTag    = (id, uid, type) => phappsRequest(p(`cards/${id}/tags`), 'POST', { user_id: uid, tag_type: type || 'need_help' });
export const removeTag = (id, uid)      => phappsRequest(p(`cards/${id}/tags/${uid}`), 'DELETE');

// ---- History ----
export const getHistory = (id) => phappsRequest(p(`cards/${id}/history`), 'GET');

// ---- Bulk Activate (Group Deals) ----
export const bulkActivate = (groupCardId, items) =>
  phappsRequest(p(`cards/${groupCardId}/activate`), 'POST', { items });

// ---- Archive / Unarchive ----
export const archiveCard     = (id)       => phappsRequest(p(`cards/${id}/archive`),   'POST', {});
export const unarchiveCard   = (id)       => phappsRequest(p(`cards/${id}/unarchive`), 'POST', {});
export const getArchivedCards = (board_id) => phappsRequest(p('cards', { board_id, archived: 1, limit: 500 }), 'GET');

// ---- Helpers ----
export const getJobTypes = () => phappsRequest(p('job-types'), 'GET');

// ---- Trello integration ----
export const getTrelloBoardsLists  = () => phappsRequest(p('trello/boards-lists'), 'GET');
export const getTrelloBoardMembers = (boardId) => phappsRequest(p(`trello/board-members/${boardId}`), 'GET');
export const suggestTrelloTitle    = (cardId) => phappsRequest(p(`cards/${cardId}/suggest-trello-title`), 'GET');
export const sendCardToTrello      = (cardId, trello_list_id, notes, trello_member_id, card_title) =>
  phappsRequest(p(`cards/${cardId}/send-to-trello`), 'POST', {
    trello_list_id,
    ...(notes            ? { notes }            : {}),
    ...(trello_member_id ? { trello_member_id } : {}),
    ...(card_title       ? { card_title }       : {}),
  });

export const getChemists = (excludeLinked = false) =>
  phappsRequest(p('chemists', excludeLinked ? { exclude_linked: '1' } : undefined), 'GET');
export const getManagers = () => phappsRequest(p('managers'), 'GET');
export const getGroups   = () => phappsRequest(p('groups'), 'GET');
export const populateGroup = (cardId) => phappsRequest(p(`cards/${cardId}/populate-group`), 'POST', {});
